import { useState, type ReactNode } from "react";

export default function LeagueCover({ imageUrl, children }: { imageUrl?: string; children?: ReactNode }) {
  const [failedUrl, setFailedUrl] = useState("");
  const hasImage = Boolean(imageUrl && imageUrl !== failedUrl);
  return <div className="league-cover">
    {hasImage
      ? <img src={imageUrl} alt="" loading="lazy" onError={() => setFailedUrl(imageUrl || "")} />
      : <span className="league-cover-placeholder material-symbols-outlined" aria-hidden="true">emoji_events</span>}
    {children}
  </div>;
}
